module.exports = __webpack_public_path__ + "static/UT_2P_traditional_v2-3c0db294a9a7474cab7096248d280ae7.png";